<div class="root-container ck-preview-container"
     [innerHTML]="content() | safeHtml"
    #preview_container
>
</div>